import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import Card from "../../../../components/card/card";
import Tabs from "../../../../components/tabs/tabs";
import { selectIsMatchInProgress } from "../../../../redux/broadcast/broadcast.selectors";
import { UpdatesTextProvider } from "./hooks/use-updates-text";
import CardsUpdatesControls from "./sub-modules/cards/cards-updates-controls";
import GoalsUpdatesControls from "./sub-modules/goals/goals-updates-controls";
import StandardUpdateControls from "./sub-modules/standard-updates/standard-updates-controls";
import * as CSS from "./updates-module.styles";

type TabIds = "standard" | "goals" | "cards";

const UpdatesModule = () => {
	const [activeTab, setActiveTab] = useState<TabIds>("standard");
	const matchInProgress = useSelector(selectIsMatchInProgress);

	const updateControls = useMemo(() => {
		if (activeTab === "goals") {
			return <GoalsUpdatesControls />;
		}

		if (activeTab === "cards") {
			return <CardsUpdatesControls />;
		}

		return <StandardUpdateControls />;
	}, [activeTab]);

	return (
		<CSS.UpdatesModule>
			<Card
				title="Updates"
				header={
					<Tabs
						activeTab={activeTab}
						onChange={(id) => setActiveTab(id as TabIds)}
						items={[
							{
								id: "standard",
								label: "Standard",
							},
							{
								id: "goals",
								label: "Goals",
								disabled: !matchInProgress,
							},
							{
								id: "cards",
								label: "Cards",
								disabled: !matchInProgress,
							},
						]}
					/>
				}
			>
				<UpdatesTextProvider>{updateControls}</UpdatesTextProvider>
			</Card>
		</CSS.UpdatesModule>
	);
};

export default UpdatesModule;
